import { FinnairPassengerItem } from '@fcom/dapi/api/models';

import { FrequentFlyerTierLevel } from '../enums';

export const getCMSTier = (tier: string): string => {
  switch (tier) {
    case FrequentFlyerTierLevel.JUNIOR.toString():
      return 'JUNIOR';
    case FrequentFlyerTierLevel.PLUS.toString():
      return 'BASIC';
    case FrequentFlyerTierLevel.SILVER.toString():
      return 'SILVER';
    case FrequentFlyerTierLevel.GOLD.toString():
      return 'GOLD';
    case FrequentFlyerTierLevel.PLATINUM.toString():
      return 'PLATINUM';
    case FrequentFlyerTierLevel.LUMO.toString():
      return 'PLATINUM LUMO';
    default:
      return '';
  }
};

export const capitalizeEveryWordFirstLetter = (str: string | undefined): string | undefined => {
  if (str !== undefined && str.trim() !== '') {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  return undefined;
};

export const getPassengerTierLevel = (
  passengerId: string,
  passengerItems: FinnairPassengerItem[]
): string | undefined => {
  const passenger = passengerItems.find(({ id }) => id === passengerId);
  const tier = (passenger?.frequentFlyerCards || [])
    .find((c) => c.companyCode && c.companyCode.toLowerCase() === 'ay')
    ?.tierLevel?.toString();
  return tier ? capitalizeEveryWordFirstLetter(getCMSTier(tier)) : undefined;
};
